<script>
    export default {
        name: "AccessLevel"
    }
</script>

<style scoped>

</style>